import { useNavigate } from 'react-router-dom'
import AuthBase from '../../../../common/components/Auth/AuthBase'
import Button from '../../../../common/components/Button'
import styles from './Success.module.css'
import { t } from 'i18next'

const SuccessPage = () => {
  const navigate = useNavigate()

  const handleSignIn = () => {
    navigate('/')
  }

  return (
    <AuthBase>
      <div className={styles.container}>
        <p className={styles.formSubtitle}>{t('login.resetSuccess')}</p>
        <div>
          <Button title={t('login.signIn')} onClick={handleSignIn} />
        </div>
      </div>
    </AuthBase>
  )
}

export default SuccessPage
